export const branding = {
  appTitle: 'TFS Lounge Access',
  //hardocoding for testing(tfs team testing with eats logo)
  iconUrl:
    'https://assets.poshvine.com/merchants/tfs/lounges/admin-portal/elite-assist-logo-light.webp',
  faviconUrl:
    'https://assets.poshvine.com/merchants/tfs/lounges/admin-portal/elite-assist-logo-light.webp',
} as const;
